<template>
  <div class="c parking-lot-settings rules">
    <v-layout row wrap>
      <v-flex xs10>
        <v-btn-toggle
          v-model="dataModel.dayToggle"
          class="transparent"
          multiple
        >
          <v-btn value="mo" color="primary" flat>Mo</v-btn>
          <v-btn value="di" color="primary" flat>Di</v-btn>
          <v-btn value="mi" color="primary" flat>Mi</v-btn>
          <v-btn value="do" color="primary" flat>Do</v-btn>
          <v-btn value="fr" color="primary" flat>Fr</v-btn>
          <v-btn value="sa" color="primary" flat>Sa</v-btn>
          <v-btn value="so" color="primary" flat>So</v-btn>
        </v-btn-toggle>
      </v-flex>
      <v-flex class="text-align-right" xs2>
        <v-btn class="no-spacing" icon color="error" flat @click="removeRule">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="dataModel.startTime"
          label="Zwischen"
          mask="##:##"
          suffix="Uhr"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="Und"
          v-model="dataModel.endTime"
          mask="##:##"
          suffix="Uhr"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label="Maximale Standzeit"
          v-model="dataModel.maxTime"
          suffix="Stunden"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'parking-lot-settings-rules',

  props: {
    data: {
      type: Object,
      required: true,
    },
    index: {
      required: true,
    },
  },

  data() {
    return {
      dataModel: {
        dayToggle: [],
        startTime: '',
        endTime: '',
        maxTime: '',
      },
    };
  },

  watch: {
    dataModel: {
      handler() {
        this.$emit('change', { index: this.index, data: this.dataModel });
      },
      deep: true,
    },
  },

  methods: {
    removeRule() {
      this.$emit('delete', { index: this.index, data: this.dataModel });
    },
  },

  mounted() {
    this.dataModel = this.data;
  },
};
</script>
